import { IDepartment } from './Interfaces';

export interface IDepartmentsState {
    departments: Array<IDepartment> | null;
}

export const initialDepartmentsState: IDepartmentsState = {
    departments: null,
};
